'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

require('../../src/styles/style.scss');

var _doctifyWfGroupReviews = require('./doctify-wf-group-reviews');

var _doctifyWfGroupReviews2 = _interopRequireDefault(_doctifyWfGroupReviews);

var _widgetActions = require('../actions/widget-actions');

var _constats = require('../utils/constats');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _$split = (typeof navigator !== 'undefined' && navigator.languages || ['en'])[0].split('-'),
    locale = _$split[0];

var localeData = require('react-intl/locale-data/' + locale);
var defaultMessages = require('../../src/lang/en.json');
var messages = void 0;
try {
    var localeMessages = require('../../src/lang/' + locale + '.json');
    messages = (0, _extends3.default)({}, defaultMessages, localeMessages);
} catch (error) {
    messages = defaultMessages;
}
(0, _reactIntl.addLocaleData)(localeData);

var WfGroupReviewsWidget = function WfGroupReviewsWidget(props) {
    var href = props.link || props.profileId && props.profileType && 'https://www.doctify.com/uk' + '/' + props.profileType.slice(0, -1) + '/' + props.profileId;
    return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: locale, messages: messages },
        _react2.default.createElement(_doctifyWfGroupReviews2.default, (0, _extends3.default)({}, props, { href: href }))
    );
};

WfGroupReviewsWidget.displayName = 'WfGroupReviewsWidget';

WfGroupReviewsWidget.defaultProps = {};

var mapStateToProps = function mapStateToProps(_ref) {
    var wfGroupReviews = _ref.wfGroupReviews;

    return {
        averageRating: wfGroupReviews.widget.averageRating,
        totalReviews: wfGroupReviews.widget.totalReviews,
        totalRecommendations: wfGroupReviews.widget.totalRecommendations,

        profileType: wfGroupReviews.widget.profileType,
        profileId: wfGroupReviews.widget.profileId,
        baseUrl: wfGroupReviews.widget.baseUrl,

        link: wfGroupReviews.widget.link,
        responsiveId: wfGroupReviews.widget.responsiveId,
        bodyStyle: wfGroupReviews.widget.bodyStyle,
        reviewItemBackground: wfGroupReviews.widget.reviewItemBackground,
        recommendationItemBackground: wfGroupReviews.widget.reviewItemBackground,
        reviewItemFrame: wfGroupReviews.widget.reviewItemFrame,
        recommendationItemFrame: wfGroupReviews.widget.reviewItemFrame,

        tabs: wfGroupReviews.widget.tabs,
        activeTab: wfGroupReviews.widget.activeTab,

        reviews: wfGroupReviews.widget.reviews,
        recommendations: wfGroupReviews.widget.recommendations,
        offset: wfGroupReviews.widget.offset,

        reviewsLimit: wfGroupReviews.widget.reviewsLimit,
        recommendationsLimit: wfGroupReviews.widget.recommendationsLimit,

        reviewsProfileType: wfGroupReviews.widget.reviewsProfileType,
        reviewsProfileId: wfGroupReviews.widget.reviewsProfileId,

        practices: wfGroupReviews.widget.practices,
        activePractice: wfGroupReviews.widget.activePractice,

        specialists: wfGroupReviews.widget.specialists,
        activeSpecialist: wfGroupReviews.widget.activeSpecialist,

        showSpecialistImageInReview: wfGroupReviews.widget.showSpecialistImageInReview,
        showPracticeImageInReview: wfGroupReviews.widget.showPracticeImageInReview,
        showProfileLogo: wfGroupReviews.widget.showProfileLogo,

        wrapperFrame: wfGroupReviews.widget.wrapperFrame,

        minReviewRating: wfGroupReviews.widget.minReviewRating
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        loadReviews: function loadReviews(reviewsProfileType, reviewsProfilesIds, direction, props) {
            var newOffset = direction === 'next' ? props.offset + props.reviewsLimit : props.offset - props.reviewsLimit;
            if (newOffset < 0 || newOffset >= props.totalReviews) {
                return new _promise2.default(function (resolve) {
                    return resolve();
                });
            }

            return (0, _constats.loadProfilesReviews)(reviewsProfilesIds, reviewsProfileType, props.reviewsLimit, newOffset, props.minReviewRating, dispatch);
        },
        resize: function resize(reviewsLimit, recommendationsLimit, props) {
            dispatch(_widgetActions.widgetActions.changeReviewsLimit(reviewsLimit));
            dispatch(_widgetActions.widgetActions.changeRecommendationsLimit(recommendationsLimit));
            switch (props.activeTab) {
                case _constats.PRACTICE_REVIEWS_TAB:
                    if (reviewsLimit > props.reviews.length) {
                        var practices = props.practices,
                            activePractice = props.activePractice,
                            offset = props.offset,
                            minReviewRating = props.minReviewRating;

                        return (0, _constats.loadProfilesReviews)(activePractice && [activePractice] || (0, _constats.getProfilesIds)(practices), _constats.QUERY_PRACTICES_PROFILE_TYPE, reviewsLimit, offset, minReviewRating, dispatch);
                    }
                    break;
            }
            return new _promise2.default(function (resolve) {
                return resolve();
            });
        },
        changeTab: function changeTab(targetTab, props) {
            if (targetTab !== props.activeTab) {
                dispatch(_widgetActions.widgetActions.changeTab(targetTab));
                dispatch(_widgetActions.widgetActions.changeSpecialist(undefined));

                var practices = props.practices,
                    reviewsLimit = props.reviewsLimit,
                    minReviewRating = props.minReviewRating;


                switch (targetTab) {
                    case _constats.PRACTICE_REVIEWS_TAB:
                        return (0, _constats.loadProfilesReviews)((0, _constats.getProfilesIds)(practices), _constats.QUERY_PRACTICES_PROFILE_TYPE, reviewsLimit, 0, minReviewRating, dispatch);
                }
            }
            return new _promise2.default(function (resolve) {
                return resolve();
            });
        },
        changeSpecialist: function changeSpecialist(targetSpecialist, props) {
            if (targetSpecialist.id && props.activeSpecialist && targetSpecialist.id !== props.activeSpecialist.id || targetSpecialist.id && !props.activeSpecialist) {
                dispatch(_widgetActions.widgetActions.changeSpecialist(targetSpecialist));
                dispatch(_widgetActions.widgetActions.changeOffset(0));
            } else if (targetSpecialist.id === undefined) {
                dispatch(_widgetActions.widgetActions.changeSpecialist(targetSpecialist));
                dispatch(_widgetActions.widgetActions.changeOffset(0));
            }
            return new _promise2.default(function (resolve) {
                return resolve();
            });
        },
        changePractice: function changePractice(targetPractice, props) {
            var practices = props.practices,
                reviewsLimit = props.reviewsLimit,
                minReviewRating = props.minReviewRating;


            if (targetPractice.id && props.activePractice && targetPractice.id !== props.activePractice.id || targetPractice.id && !props.activePractice) {
                dispatch(_widgetActions.widgetActions.changePractice(targetPractice));
                dispatch(_widgetActions.widgetActions.changeOffset(0));

                switch (props.activeTab) {
                    case _constats.PRACTICE_REVIEWS_TAB:
                        return (0, _constats.loadProfileReviews)(targetPractice.id, _constats.QUERY_PRACTICES_PROFILE_TYPE, reviewsLimit, 0, minReviewRating, dispatch);
                }
            } else if (targetPractice.id === undefined) {
                dispatch(_widgetActions.widgetActions.changePractice(targetPractice));
                dispatch(_widgetActions.widgetActions.changeOffset(0));
                switch (props.activeTab) {
                    case _constats.PRACTICE_REVIEWS_TAB:
                        return (0, _constats.loadProfilesReviews)((0, _constats.getProfilesIds)(practices), _constats.QUERY_PRACTICES_PROFILE_TYPE, reviewsLimit, 0, minReviewRating, dispatch);
                }
            }
            return new _promise2.default(function (resolve) {
                return resolve();
            });
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WfGroupReviewsWidget);
